// @flow

/* Libs */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useUserStore from 'Stores/User';
import useEtsyStore from 'Stores/Etsy';
import useSquarespaceStore from 'Stores/Squarespace';

/* Components */
import Header from 'Components/Header';
import Button from 'Components/Button';

const Home = () => {
	const currentUser = useUserStore(store => store.currentUser);
	const connectEtsy = useEtsyStore(store => store.connectEtsy);
	const getInventory = useEtsyStore(store => store.getInventory);
	const getCountries = useEtsyStore(store => store.getCountries);
	const getOrder = useEtsyStore(store => store.getOrder);
	const getTransactions = useEtsyStore(store => store.getTransactions);
	const getSquarespaceOrder = useSquarespaceStore(store => store.getSquarespaceOrder);
	const { pathname, search } = useLocation();

	useEffect(() => {
		if (pathname.includes('/etsy/callback')) {
			console.log('search', search);
			connectEtsy({ isCallback: true, search });
		}
	}, [pathname]);

	return (
		<div>
			<Header title="Home" />

			{ currentUser && !currentUser.isLinkedWithEtsy && (
				<Button action={connectEtsy} text="Connect to Etsy" className="etsy" />
			)}
			{ currentUser && currentUser.isLinkedWithEtsy && (
				<Button action={getInventory} text="Sync to Etsy - Inventory" className="etsy" />
			)}
			{ currentUser && currentUser.isLinkedWithEtsy && (
				<Button action={getCountries} text="Sync to Etsy - Countries" className="etsy" />
			)}
			{ currentUser && currentUser.isLinkedWithEtsy && (
				<Button action={getOrder} text="Sync to Etsy - Get order" className="etsy" />
			)}
			{ currentUser && currentUser.isLinkedWithEtsy && (
				<Button action={getTransactions} text="Etsy - Get transactions" className="etsy" />
			)}
			{ currentUser && (
				<Button action={getSquarespaceOrder} text="Squarespace - Get order" className="etsy" />
			)}
		</div>
	);
};

export default Home;
